(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5740],{

/***/ 48491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Breadcrumbs": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.Oo; },
/* harmony export */   "BrowserClient": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.RE; },
/* harmony export */   "BrowserProfilingIntegration": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__._p; },
/* harmony export */   "BrowserTracing": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.gE; },
/* harmony export */   "Dedupe": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.Iq; },
/* harmony export */   "ErrorBoundary": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.SV; },
/* harmony export */   "Feedback": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.x2; },
/* harmony export */   "FunctionToString": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.cq; },
/* harmony export */   "GlobalHandlers": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.dJ; },
/* harmony export */   "HttpContext": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.qT; },
/* harmony export */   "Hub": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.Xb; },
/* harmony export */   "InboundFilters": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.QD; },
/* harmony export */   "Integrations": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.jK; },
/* harmony export */   "LinkedErrors": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.iP; },
/* harmony export */   "ModuleMetadata": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__._e; },
/* harmony export */   "Profiler": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.Q1; },
/* harmony export */   "Replay": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.UH; },
/* harmony export */   "SDK_VERSION": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.Jn; },
/* harmony export */   "Scope": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.sX; },
/* harmony export */   "TryCatch": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.pT; },
/* harmony export */   "WINDOW": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.m9; },
/* harmony export */   "addBreadcrumb": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.n_; },
/* harmony export */   "addEventProcessor": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.Qy; },
/* harmony export */   "addGlobalEventProcessor": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.cc; },
/* harmony export */   "addIntegration": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.M5; },
/* harmony export */   "addTracingExtensions": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.Ts; },
/* harmony export */   "captureEvent": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.eN; },
/* harmony export */   "captureException": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.Tb; },
/* harmony export */   "captureMessage": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.uT; },
/* harmony export */   "captureUnderscoreErrorException": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.ud; },
/* harmony export */   "captureUserFeedback": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.Jd; },
/* harmony export */   "chromeStackLineParser": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.$3; },
/* harmony export */   "close": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.xv; },
/* harmony export */   "configureScope": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.e; },
/* harmony export */   "continueTrace": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.yn; },
/* harmony export */   "createReduxEnhancer": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.wS; },
/* harmony export */   "createTransport": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.qv; },
/* harmony export */   "createUserFeedbackEnvelope": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.rQ; },
/* harmony export */   "defaultIntegrations": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.SS; },
/* harmony export */   "defaultRequestInstrumentationOptions": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.k3; },
/* harmony export */   "defaultStackLineParsers": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.d8; },
/* harmony export */   "defaultStackParser": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.Dt; },
/* harmony export */   "eventFromException": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.dr; },
/* harmony export */   "eventFromMessage": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.aB; },
/* harmony export */   "exceptionFromError": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.GJ; },
/* harmony export */   "extractTraceparentData": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.qG; },
/* harmony export */   "flush": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.yl; },
/* harmony export */   "forceLoad": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.Eg; },
/* harmony export */   "geckoStackLineParser": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.$Q; },
/* harmony export */   "getActiveSpan": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.HN; },
/* harmony export */   "getActiveTransaction": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.x1; },
/* harmony export */   "getClient": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.s3; },
/* harmony export */   "getCurrentHub": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.Gd; },
/* harmony export */   "getCurrentScope": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.nZ; },
/* harmony export */   "getHubFromCarrier": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.vi; },
/* harmony export */   "init": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.S1; },
/* harmony export */   "instrumentOutgoingRequests": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.L7; },
/* harmony export */   "lastEventId": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.eW; },
/* harmony export */   "makeBrowserOfflineTransport": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.O1; },
/* harmony export */   "makeFetchTransport": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.fD; },
/* harmony export */   "makeMain": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.pj; },
/* harmony export */   "makeMultiplexedTransport": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.Wq; },
/* harmony export */   "makeXHRTransport": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.KC; },
/* harmony export */   "metrics": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.qI; },
/* harmony export */   "nextRouterInstrumentation": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.q$; },
/* harmony export */   "onLoad": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.lA; },
/* harmony export */   "onProfilingStartRouteTransaction": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.Uv; },
/* harmony export */   "opera10StackLineParser": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.NP; },
/* harmony export */   "opera11StackLineParser": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.HH; },
/* harmony export */   "reactRouterV3Instrumentation": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.XQ; },
/* harmony export */   "reactRouterV4Instrumentation": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.qr; },
/* harmony export */   "reactRouterV5Instrumentation": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.qp; },
/* harmony export */   "reactRouterV6Instrumentation": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.KO; },
/* harmony export */   "setContext": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.v; },
/* harmony export */   "setExtra": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.sU; },
/* harmony export */   "setExtras": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.rJ; },
/* harmony export */   "setMeasurement": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.oi; },
/* harmony export */   "setTag": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.YA; },
/* harmony export */   "setTags": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.mG; },
/* harmony export */   "setUser": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.av; },
/* harmony export */   "showReportDialog": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.jp; },
/* harmony export */   "spanStatusfromHttpCode": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.Zd; },
/* harmony export */   "startInactiveSpan": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.Qb; },
/* harmony export */   "startSpan": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.GK; },
/* harmony export */   "startSpanManual": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.V0; },
/* harmony export */   "startTransaction": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.Yr; },
/* harmony export */   "trace": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.g4; },
/* harmony export */   "useProfiler": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.ED; },
/* harmony export */   "winjsStackLineParser": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.R2; },
/* harmony export */   "withErrorBoundary": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.Pf; },
/* harmony export */   "withProfiler": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.zH; },
/* harmony export */   "withScope": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.$e; },
/* harmony export */   "withSentryConfig": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.wO; },
/* harmony export */   "withSentryGetServerSideProps": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.sT; },
/* harmony export */   "withSentryGetStaticProps": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.SF; },
/* harmony export */   "withSentryReactRouterV6Routing": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.H0; },
/* harmony export */   "withSentryRouting": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.gy; },
/* harmony export */   "withSentryServerSideAppGetInitialProps": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.Im; },
/* harmony export */   "withSentryServerSideDocumentGetInitialProps": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.W9; },
/* harmony export */   "withSentryServerSideErrorGetInitialProps": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.vw; },
/* harmony export */   "withSentryServerSideGetInitialProps": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.EC; },
/* harmony export */   "withServerActionInstrumentation": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.NF; },
/* harmony export */   "wrap": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.re; },
/* harmony export */   "wrapApiHandlerWithSentryVercelCrons": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.LH; },
/* harmony export */   "wrapAppGetInitialPropsWithSentry": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.$l; },
/* harmony export */   "wrapCreateBrowserRouter": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.vG; },
/* harmony export */   "wrapDocumentGetInitialPropsWithSentry": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.B4; },
/* harmony export */   "wrapErrorGetInitialPropsWithSentry": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.rO; },
/* harmony export */   "wrapGenerationFunctionWithSentry": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.J$; },
/* harmony export */   "wrapGetInitialPropsWithSentry": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.O5; },
/* harmony export */   "wrapGetServerSidePropsWithSentry": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.rC; },
/* harmony export */   "wrapGetStaticPropsWithSentry": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.ug; },
/* harmony export */   "wrapMiddlewareWithSentry": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.l7; },
/* harmony export */   "wrapPageComponentWithSentry": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.ri; },
/* harmony export */   "wrapRouteHandlerWithSentry": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.zv; },
/* harmony export */   "wrapServerComponentWithSentry": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.D_; },
/* harmony export */   "wrapUseRoutes": function() { return /* reexport safe */ _client__WEBPACK_IMPORTED_MODULE_0__.M1; }
/* harmony export */ });
/* harmony import */ var _client__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37950);


/***/ }),

/***/ 47443:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(42118);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),

/***/ 1196:
/***/ (function(module) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),

/***/ 5336:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseEach = __webpack_require__(89881);

/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function baseFilter(collection, predicate) {
  var result = [];
  baseEach(collection, function(value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });
  return result;
}

module.exports = baseFilter;


/***/ }),

/***/ 41848:
/***/ (function(module) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),

/***/ 21078:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(62488),
    isFlattenable = __webpack_require__(37285);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),

/***/ 42118:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(41848),
    baseIsNaN = __webpack_require__(62722),
    strictIndexOf = __webpack_require__(42351);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),

/***/ 62722:
/***/ (function(module) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),

/***/ 45652:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var SetCache = __webpack_require__(88668),
    arrayIncludes = __webpack_require__(47443),
    arrayIncludesWith = __webpack_require__(1196),
    cacheHas = __webpack_require__(74757),
    createSet = __webpack_require__(23593),
    setToArray = __webpack_require__(21814);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),

/***/ 54290:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var identity = __webpack_require__(6557);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),

/***/ 23593:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Set = __webpack_require__(58525),
    noop = __webpack_require__(50308),
    setToArray = __webpack_require__(21814);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),

/***/ 37285:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705),
    isArguments = __webpack_require__(35694),
    isArray = __webpack_require__(1469);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),

/***/ 42351:
/***/ (function(module) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),

/***/ 63105:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayFilter = __webpack_require__(34963),
    baseFilter = __webpack_require__(5336),
    baseIteratee = __webpack_require__(67206),
    isArray = __webpack_require__(1469);

/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 *
 * // Combining several predicates using `_.overEvery` or `_.overSome`.
 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
 * // => objects for ['fred', 'barney']
 */
function filter(collection, predicate) {
  var func = isArray(collection) ? arrayFilter : baseFilter;
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = filter;


/***/ }),

/***/ 29246:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArrayLike = __webpack_require__(81240),
    isObjectLike = __webpack_require__(37005);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),

/***/ 13880:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toString = __webpack_require__(79833);

/**
 * Replaces matches for `pattern` in `string` with `replacement`.
 *
 * **Note:** This method is based on
 * [`String#replace`](https://mdn.io/String/replace).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to modify.
 * @param {RegExp|string} pattern The pattern to replace.
 * @param {Function|string} replacement The match replacement.
 * @returns {string} Returns the modified string.
 * @example
 *
 * _.replace('Hi Fred', 'Fred', 'Barney');
 * // => 'Hi Barney'
 */
function replace() {
  var args = arguments,
      string = toString(args[0]);

  return args.length < 3 ? string : string.replace(args[1], args[2]);
}

module.exports = replace;


/***/ }),

/***/ 98913:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTimes = __webpack_require__(22545),
    castFunction = __webpack_require__(54290),
    toInteger = __webpack_require__(40554);

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Invokes the iteratee `n` times, returning an array of the results of
 * each invocation. The iteratee is invoked with one argument; (index).
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 * @example
 *
 * _.times(3, String);
 * // => ['0', '1', '2']
 *
 *  _.times(4, _.constant(0));
 * // => [0, 0, 0, 0]
 */
function times(n, iteratee) {
  n = toInteger(n);
  if (n < 1 || n > MAX_SAFE_INTEGER) {
    return [];
  }
  var index = MAX_ARRAY_LENGTH,
      length = nativeMin(n, MAX_ARRAY_LENGTH);

  iteratee = castFunction(iteratee);
  n -= MAX_ARRAY_LENGTH;

  var result = baseTimes(length, iteratee);
  while (++index < n) {
    iteratee(index);
  }
  return result;
}

module.exports = times;


/***/ }),

/***/ 93386:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFlatten = __webpack_require__(21078),
    baseRest = __webpack_require__(5976),
    baseUniq = __webpack_require__(45652),
    isArrayLikeObject = __webpack_require__(29246);

/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */
var union = baseRest(function(arrays) {
  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
});

module.exports = union;


/***/ }),

/***/ 78330:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/generated-templates/one-pager-asset-template-page",
      function () {
        return __webpack_require__(44353);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 44133:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ AssetPartComponent; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(60357);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/core/video/video-component.js + 1 modules
var video_component = __webpack_require__(3773);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
;// CONCATENATED MODULE: ./components/core/one-pager/asset-part/asset-part-component.scss.js

var _defaultExport = new String(".asset-part-component.jsx-66cf28cb47c773ef{width:100%;height:100%;video {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n    }\n\n    &.half-width {\n      display: flex;\n      justify-content: flex-end;\n    }\n  }");
_defaultExport.__hash = "66cf28cb47c773ef";
/* harmony default export */ var asset_part_component_scss = (_defaultExport);

;// CONCATENATED MODULE: ./components/core/one-pager/asset-part/asset-part-component.js









var AssetPartComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(AssetPartComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(AssetPartComponent);
    function AssetPartComponent() {
        (0,_class_call_check/* default */.Z)(this, AssetPartComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(AssetPartComponent, [
        {
            key: "getVideoType",
            value: function getVideoType(videoUrl) {
                return videoUrl.split(".").pop();
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, playsInline = _props.playsInline, autoPlay = _props.autoPlay, muted = _props.muted, loop = _props.loop, theme = _props.theme;
                var _assetProps = this.props.assetProps, formats = _assetProps.formats, poster = _assetProps.poster;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "jsx-".concat(asset_part_component_scss.__hash) + " " + "asset-part-component ".concat(theme),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(video_component/* default */.Z, {
                            formats: formats,
                            loop: loop,
                            muted: muted,
                            poster: poster,
                            playsInline: playsInline,
                            autoPlay: autoPlay
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: asset_part_component_scss.__hash,
                            children: asset_part_component_scss
                        })
                    ]
                });
            }
        }
    ]);
    return AssetPartComponent;
}(react.PureComponent);

AssetPartComponent.defaultProps = {
    playsInline: true,
    autoPlay: true,
    muted: true,
    loop: true
};


/***/ }),

/***/ 73418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ hamburger_menu_component; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./client/services/accessibility/accessibility-service.js
var accessibility_service = __webpack_require__(60696);
// EXTERNAL MODULE: ./contexts/generic-config-context.js
var generic_config_context = __webpack_require__(3156);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./styles/colors.js
var colors = __webpack_require__(12573);
// EXTERNAL MODULE: ./constants/z-index.js
var z_index = __webpack_require__(35257);
;// CONCATENATED MODULE: ./components/core/top-bar-new/hamburger-menu/hamburger-menu-component.scss.js



var StyledHamburgerMenuComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e10ajo1f0"
})("width:28px;transform:rotate(0deg);cursor:pointer;z-index:", z_index/* SIDE_NAV */.gR + 1, ";margin-left:24px;margin-right:8px;height:36px;display:flex;.hamburger-menu-line{display:block;position:absolute;height:3px;width:100%;background-color:", colors/* default.black */.Z.black, ";border-radius:4px;opacity:1;left:0;transform:rotate(0deg);transition:all 0.2s ease-in-out;&:nth-child(1){top:8px;}&:nth-child(2),&:nth-child(3){top:17px;}&:nth-child(4){top:26px;}}&.open{.hamburger-menu-line{background-color:", colors/* default.black */.Z.black, ";&:nth-child(1){top:18px;width:0%;left:50%;}&:nth-child(2){transform:rotate(45deg);}&:nth-child(3){transform:rotate(-45deg);}&:nth-child(4){top:18px;width:0;left:50%;}}}");

;// CONCATENATED MODULE: ./components/core/top-bar-new/hamburger-menu/hamburger-menu-component.js










var HamburgerMenuComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(HamburgerMenuComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(HamburgerMenuComponent);
    function HamburgerMenuComponent(props) {
        (0,_class_call_check/* default */.Z)(this, HamburgerMenuComponent);
        var _this;
        _this = _super.call(this, props);
        _this.toggleOpenState = _this.toggleOpenState.bind((0,_assert_this_initialized/* default */.Z)(_this));
        _this.onKeyDown = (0,accessibility_service/* generateOnKeyDownHandler */.vR)(_this.toggleOpenState);
        return _this;
    }
    (0,_create_class/* default */.Z)(HamburgerMenuComponent, [
        {
            key: "toggleOpenState",
            value: function toggleOpenState() {
                var isOpen = this.props.isOpen;
                this.props.changeStateCallback(!isOpen);
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, theme = _props.theme, isInScrollMode = _props.isInScrollMode, isOpen = _props.isOpen, translate = _props.translate;
                var scrollModeClass = isInScrollMode ? "scroll-mode" : "";
                var openMode = isOpen ? "open" : "";
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledHamburgerMenuComponent, {
                    className: "hamburger-menu ".concat(theme, " ").concat(scrollModeClass, " ").concat(openMode),
                    tabIndex: 0,
                    onClick: this.toggleOpenState,
                    onKeyDown: this.onKeyDown,
                    onMouseDown: accessibility_service/* preventFocusOnMouseDown */.$R,
                    "aria-label": isOpen ? translate("header.closeMenu") : translate("header.openMenu"),
                    "aria-haspopup": "menu",
                    "aria-expanded": isOpen,
                    role: "button",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "hamburger-menu-line"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "hamburger-menu-line"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "hamburger-menu-line"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "hamburger-menu-line"
                        })
                    ]
                });
            }
        }
    ]);
    return HamburgerMenuComponent;
}(react.PureComponent);
HamburgerMenuComponent.defaultProps = {
    changeStateCallback: function() {},
    isInScrollMode: false,
    theme: "",
    isOpen: false
};
/* harmony default export */ var hamburger_menu_component = ((0,generic_config_context/* withGenericConfig */.P)(HamburgerMenuComponent));


/***/ }),

/***/ 87355:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ OnePagerAssetTemplate; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 4 modules
var _create_super = __webpack_require__(60460);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/core/top-bar-new/top-bar-component.js + 33 modules
var top_bar_component = __webpack_require__(21882);
// EXTERNAL MODULE: ./components/addons/core-addons/core-addons-component.js + 8 modules
var core_addons_component = __webpack_require__(48124);
// EXTERNAL MODULE: ./components/templates/base-template.js + 69 modules
var base_template = __webpack_require__(14148);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./components/core/one-pager/asset-part/asset-part-component.js + 1 modules
var asset_part_component = __webpack_require__(44133);
// EXTERNAL MODULE: ./components/core/one-pager/desktop-content/text-part/text-part-component.js + 5 modules
var text_part_component = __webpack_require__(63126);
// EXTERNAL MODULE: ./contexts/ab-tests-context.js
var ab_tests_context = __webpack_require__(24492);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 7 modules
var emotion_styled_browser_esm = __webpack_require__(77521);
// EXTERNAL MODULE: ./constants/vp-sizes.js
var vp_sizes = __webpack_require__(698);
;// CONCATENATED MODULE: ./components/templates/one-pager-asset-template/one-pager-asset-content/desktop-content/desktop-content-component.scss.js


var StyledDesktopContentComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e44zhjk0"
})("height:100%;.asset-part-wrapper{width:100%;height:100%;}.text-part-wrapper{position:absolute;top:0;bottom:0;left:0;width:56vw;display:flex;align-items:center;padding:16px 0 16px 80px;}@media (max-width:", vp_sizes/* TABLET_QUERY_MAX_WIDTH */.y, "){.text-part-wrapper{padding:16px 0 16px 54px;}}");

;// CONCATENATED MODULE: ./components/templates/one-pager-asset-template/one-pager-asset-content/desktop-content/desktop-content-component.js




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






var DesktopContentComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(DesktopContentComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(DesktopContentComponent);
    function DesktopContentComponent() {
        (0,_class_call_check/* default */.Z)(this, DesktopContentComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(DesktopContentComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, assetPart = _props.assetPart, textPart = _props.textPart, _signupForm = _props.signupForm, signupForm = _signupForm === void 0 ? {} : _signupForm, collaborationWith = _props.collaborationWith, popupVideo = _props.popupVideo, abTests = _props.abTests;
                signupForm.focusOnLoad = true;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledDesktopContentComponent, {
                    className: "desktop-content-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "asset-part-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(asset_part_component/* default */.Z, {
                                assetType: assetPart.type,
                                assetProps: assetPart.props
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "text-part-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_part_component/* default */.Z, _object_spread_props(_object_spread({}, textPart), {
                                signupForm: signupForm,
                                collaborationWith: collaborationWith,
                                popupVideo: popupVideo
                            }))
                        })
                    ]
                });
            }
        }
    ]);
    return DesktopContentComponent;
}(react.PureComponent);
/* harmony default export */ var desktop_content_component = ((0,ab_tests_context/* withAbTests */.k)(DesktopContentComponent));

// EXTERNAL MODULE: ./node_modules/styled-jsx/style.js
var style = __webpack_require__(60357);
var style_default = /*#__PURE__*/__webpack_require__.n(style);
// EXTERNAL MODULE: ./components/core/one-pager/mobile-content/text-part/text-part-component.js + 3 modules
var text_part_text_part_component = __webpack_require__(57858);
// EXTERNAL MODULE: ./services/community/url-service.js
var url_service = __webpack_require__(932);
;// CONCATENATED MODULE: ./components/core/one-pager/mobile-asset-content/mobile-asset-content-component.scss.js
var _defaultExport = new String(".mobile-asset-content-component{height:100%;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;text-align:center;-webkit-background-size:cover!important;-moz-background-size:cover!important;-o-background-size:cover!important;background-size:cover!important;.text-part-component{.subtitle-lines-wrapper{margin-bottom:24px!important}}.asset-part-wrapper{-webkit-box-flex:1;-webkit-flex:1;-moz-box-flex:1;-ms-flex:1;flex:1;width:100vw;position:relative;padding-top:24px;.asset-part{width:100%;height:100%;position:absolute;-webkit-background-size:contain;-moz-background-size:contain;-o-background-size:contain;background-size:contain;background-repeat:no-repeat;background-position:center}}}");
_defaultExport.__hash = "d8c69559db605e67";
/* harmony default export */ var mobile_asset_content_component_scss = (_defaultExport);

;// CONCATENATED MODULE: ./components/core/one-pager/mobile-asset-content/mobile-asset-content-component.js




function mobile_asset_content_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function mobile_asset_content_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            mobile_asset_content_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function mobile_asset_content_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function mobile_asset_content_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        mobile_asset_content_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}






var MobileAssetContentComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(MobileAssetContentComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(MobileAssetContentComponent);
    function MobileAssetContentComponent() {
        (0,_class_call_check/* default */.Z)(this, MobileAssetContentComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(MobileAssetContentComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, textPart = _props.textPart, mobileAssetType = _props.mobileAssetType, signupForm = _props.signupForm, collaborationWith = _props.collaborationWith;
                collaborationWith.color = "black";
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "jsx-".concat(mobile_asset_content_component_scss.__hash) + " " + "mobile-asset-content-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-".concat(mobile_asset_content_component_scss.__hash) + " " + "text-part-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_part_text_part_component/* default */.Z, mobile_asset_content_component_object_spread_props(mobile_asset_content_component_object_spread({}, textPart), {
                                signupForm: signupForm,
                                collaborationWith: collaborationWith,
                                color: "black"
                            }))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-".concat(mobile_asset_content_component_scss.__hash) + " " + "asset-part-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    backgroundImage: "url(".concat((0,url_service.fixDevImageUrl)(mobileAssetType), ")")
                                },
                                className: "jsx-".concat(mobile_asset_content_component_scss.__hash) + " " + "asset-part"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: mobile_asset_content_component_scss.__hash,
                            children: mobile_asset_content_component_scss
                        })
                    ]
                });
            }
        }
    ]);
    return MobileAssetContentComponent;
}(react.PureComponent);

MobileAssetContentComponent.defaultProps = {
    mobileAssetType: "/static/img/one-pager/mobile/m-statuses-with-hand.gif",
    collaborationWith: {}
};

;// CONCATENATED MODULE: ./components/core/one-pager/mobile-background-gif-content/mobile-background-gif-content-component.scss.js
var mobile_background_gif_content_component_scss_defaultExport = new String(".mobile-background-gif-content-component.jsx-31f3db773df3688c{height:100%;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-moz-box-orient:vertical;-moz-box-direction:normal;-ms-flex-direction:column;flex-direction:column;-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;text-align:center;-webkit-background-size:cover!important;-moz-background-size:cover!important;-o-background-size:cover!important;background-size:cover!important;.asset-part-wrapper.jsx-31f3db773df3688c{-webkit-box-flex:1;-webkit-flex:1;-moz-box-flex:1;-ms-flex:1;flex:1;width:100vw;.asset-part.jsx-31f3db773df3688c{width:100%;height:100%;-webkit-background-size:cover!important;-moz-background-size:cover!important;-o-background-size:cover!important;background-size:cover!important;background-position:center!important}}}");
mobile_background_gif_content_component_scss_defaultExport.__hash = "31f3db773df3688c";
/* harmony default export */ var mobile_background_gif_content_component_scss = (mobile_background_gif_content_component_scss_defaultExport);

;// CONCATENATED MODULE: ./components/core/one-pager/mobile-background-gif-content/mobile-background-gif-content-component.js




function mobile_background_gif_content_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function mobile_background_gif_content_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            mobile_background_gif_content_component_define_property(target, key, source[key]);
        });
    }
    return target;
}
function mobile_background_gif_content_component_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function mobile_background_gif_content_component_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        mobile_background_gif_content_component_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}





var MobileBackgroundGifContentComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(MobileBackgroundGifContentComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(MobileBackgroundGifContentComponent);
    function MobileBackgroundGifContentComponent() {
        (0,_class_call_check/* default */.Z)(this, MobileBackgroundGifContentComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(MobileBackgroundGifContentComponent, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, textPart = _props.textPart, backgroundAsset = _props.backgroundAsset, signupForm = _props.signupForm, collaborationWith = _props.collaborationWith;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        background: "url(".concat(backgroundAsset, ")")
                    },
                    className: "jsx-".concat(mobile_background_gif_content_component_scss.__hash) + " " + "mobile-background-gif-content-component",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "jsx-".concat(mobile_background_gif_content_component_scss.__hash) + " " + "text-part-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_part_text_part_component/* default */.Z, mobile_background_gif_content_component_object_spread_props(mobile_background_gif_content_component_object_spread({}, textPart), {
                                signupForm: signupForm,
                                collaborationWith: collaborationWith,
                                color: "black"
                            }))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((style_default()), {
                            id: mobile_background_gif_content_component_scss.__hash,
                            children: mobile_background_gif_content_component_scss
                        })
                    ]
                });
            }
        }
    ]);
    return MobileBackgroundGifContentComponent;
}(react.PureComponent);

MobileBackgroundGifContentComponent.defaultProps = {
    backgroundAsset: "/static/img/one-pager/one-pager-mobile.gif",
    collaborationWith: {}
};

// EXTERNAL MODULE: ./components/segments/social-proof/social-proof-component.js + 1 modules
var social_proof_component = __webpack_require__(18925);
// EXTERNAL MODULE: ./components/segments/short-footer/short-footer-component.js
var short_footer_component = __webpack_require__(83234);
// EXTERNAL MODULE: ./constants/one-pager-asset-types.js
var one_pager_asset_types = __webpack_require__(30513);
;// CONCATENATED MODULE: ./components/templates/one-pager-asset-template/one-pager-asset-content/one-pager-asset-content-component.scss.js


var StyledOnePagerAssetContentComponent = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1ku8qxu0"
})("width:100vw;height:calc(100vh - 65px);position:relative;overflow:hidden;.desktop-content-wrapper{display:block;height:100%;}.mobile-content-wrapper{display:none;height:100%;}&.multiple-folds{overflow:visible;.desktop-content-wrapper{height:auto;.desktop-content-component{.asset-part-wrapper{.asset-part-component{.video-component{.react-player-video-component{video{width:100vw !important;height:calc(100vh - 65px) !important;object-fit:cover;}}}}}}}}@media (max-width:", vp_sizes/* MOBILE_QUERY_MAX_WIDTH */.zD, "){height:calc(100vh - 54px);.desktop-content-wrapper{display:none;}.mobile-content-wrapper{display:block;}}");

;// CONCATENATED MODULE: ./components/templates/one-pager-asset-template/one-pager-asset-content/one-pager-asset-content-component.js




function one_pager_asset_content_component_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function one_pager_asset_content_component_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            one_pager_asset_content_component_define_property(target, key, source[key]);
        });
    }
    return target;
}










var OnePagerAssetContentComponent = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(OnePagerAssetContentComponent, PureComponent);
    var _super = (0,_create_super/* default */.Z)(OnePagerAssetContentComponent);
    function OnePagerAssetContentComponent() {
        (0,_class_call_check/* default */.Z)(this, OnePagerAssetContentComponent);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(OnePagerAssetContentComponent, [
        {
            key: "getMobileVersion",
            value: function getMobileVersion() {
                var mobileVersion = this.props.mobileVersion;
                if (mobileVersion === one_pager_asset_types/* MOBILE_VERSIONS.MOBILE_ASSET */.m.MOBILE_ASSET) {
                    return MobileAssetContentComponent;
                }
                return MobileBackgroundGifContentComponent;
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, SocialProof = _props.SocialProof, ShortFooter = _props.ShortFooter;
                var showSocialProof = SocialProof.showSocialProof, socialProofContent = SocialProof.content;
                var showShortFooter = ShortFooter.showShortFooter, shortFooterContent = ShortFooter.content;
                var MobileComponent = this.getMobileVersion();
                var hasMultipleFolds = showSocialProof || showShortFooter;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledOnePagerAssetContentComponent, {
                    className: classnames_default()("one-pager-asset-content-component", {
                        "multiple-folds": hasMultipleFolds
                    }),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "desktop-content-wrapper",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(desktop_content_component, one_pager_asset_content_component_object_spread({}, this.props)),
                                showSocialProof && /*#__PURE__*/ (0,jsx_runtime.jsx)(social_proof_component/* default */.Z, one_pager_asset_content_component_object_spread({}, socialProofContent)),
                                showShortFooter && /*#__PURE__*/ (0,jsx_runtime.jsx)(short_footer_component/* default */.Z, one_pager_asset_content_component_object_spread({}, shortFooterContent))
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mobile-content-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileComponent, one_pager_asset_content_component_object_spread({}, this.props))
                        })
                    ]
                });
            }
        }
    ]);
    return OnePagerAssetContentComponent;
}(react.PureComponent);

OnePagerAssetContentComponent.defaultProps = {
    assetPart: {},
    textPart: {},
    collaborationWith: {},
    mobileVersion: one_pager_asset_types/* MOBILE_VERSIONS.MOBILE_BACKGROUND_GIF */.m.MOBILE_BACKGROUND_GIF,
    SocialProof: {},
    ShortFooter: {}
};

;// CONCATENATED MODULE: ./components/templates/one-pager-asset-template/one-pager-asset-template.js




function one_pager_asset_template_define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function one_pager_asset_template_object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            one_pager_asset_template_define_property(target, key, source[key]);
        });
    }
    return target;
}
function one_pager_asset_template_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function one_pager_asset_template_object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        one_pager_asset_template_ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}







var OnePagerAssetTemplate = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_inherits/* default */.Z)(OnePagerAssetTemplate, PureComponent);
    var _super = (0,_create_super/* default */.Z)(OnePagerAssetTemplate);
    function OnePagerAssetTemplate() {
        (0,_class_call_check/* default */.Z)(this, OnePagerAssetTemplate);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(OnePagerAssetTemplate, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, headerUrl = _props.headerUrl, exitPopup = _props.exitPopup, loginTheme = _props.loginTheme, menuTheme = _props.menuTheme, stickyMode = _props.stickyMode, pageConfig = _props.pageConfig;
                var headerStrip = pageConfig.headerStrip, parts = pageConfig.parts, footerSignup = pageConfig.footerSignup, nameSignature = pageConfig.nameSignature, socialButtons = pageConfig.socialButtons, topBanner = pageConfig.topBanner, exitPopupConfig = pageConfig.exitPopupConfig;
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(base_template/* default */.Z, one_pager_asset_template_object_spread_props(one_pager_asset_template_object_spread({}, this.props, pageConfig), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(top_bar_component/* default */.Z, {
                            url: headerUrl,
                            loginTheme: loginTheme,
                            menuTheme: menuTheme,
                            showMenu: false,
                            stickyMode: stickyMode,
                            allowSocialButtons: socialButtons && socialButtons.show,
                            socialButtonsColor: socialButtons && socialButtons.color,
                            topBanner: topBanner,
                            maxWidth: "100%",
                            headerBackgroundColor: "transparent"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OnePagerAssetContentComponent, one_pager_asset_template_object_spread({}, pageConfig))
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(core_addons_component/* default */.Z, {
                            exitPopup: exitPopup,
                            exitPopupConfig: exitPopupConfig
                        })
                    ]
                }));
            }
        }
    ]);
    return OnePagerAssetTemplate;
}(react.PureComponent);

OnePagerAssetTemplate.defaultProps = {
    headerUrl: "https://monday.com/",
    title: "monday.com",
    description: "",
    exitPopup: true,
    menuTheme: "",
    loginTheme: ""
};


/***/ }),

/***/ 30513:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ MOBILE_VERSIONS; }
/* harmony export */ });
var MOBILE_VERSIONS = {
    MOBILE_ASSET: "MOBILE_ASSET",
    MOBILE_BACKGROUND_GIF: "MOBILE_BACKGROUND_GIF"
};


/***/ }),

/***/ 79813:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ BaseTemplatePage; },
/* harmony export */   "getSerializedServerProps": function() { return /* binding */ getSerializedServerProps; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(60460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_error__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12918);
/* harmony import */ var _constants_pricing_versions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78803);
/* harmony import */ var _constants_pricing_versions__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_constants_pricing_versions__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var server_services_exceptions_handling_service_exceptions_handling_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(24730);
/* harmony import */ var server_services_exceptions_handling_service_exceptions_handling_service__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(server_services_exceptions_handling_service_exceptions_handling_service__WEBPACK_IMPORTED_MODULE_4__);









var isObject = function(obj) {
    return obj && typeof obj === "object";
};
var __N_SSP = true;
var getSerializedServerProps = function(serverProps) {
    return Object.keys(serverProps).reduce(function(result, prop) {
        if (isObject(serverProps[prop])) {
            var objectKeys = Object.keys(serverProps[prop]);
            for(var i = 0; i < objectKeys.length; i++){
                var key = objectKeys[i];
                if (serverProps[prop][key] === undefined) {
                    delete serverProps[prop][key];
                }
            }
        }
        if (serverProps[prop]) {
            result[prop] = serverProps[prop];
        }
        return result;
    }, {});
};
var BaseTemplatePage = /*#__PURE__*/ function(PureComponent) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(BaseTemplatePage, PureComponent);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(BaseTemplatePage);
    function BaseTemplatePage() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(this, BaseTemplatePage);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(BaseTemplatePage, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var pageConfig = this.props.pageConfig;
                // Track ab test if the landing page is in test.
                if (pageConfig && pageConfig.abTestVariant && pageConfig.abTestName) {
                    BigBrain("track", pageConfig.abTestName, {
                        ab_test: pageConfig.abTestVariant
                    });
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var errorCode = this.props.errorCode;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_error__WEBPACK_IMPORTED_MODULE_2__["default"], {
                    statusCode: errorCode
                });
            }
        }
    ]);
    return BaseTemplatePage;
}(react__WEBPACK_IMPORTED_MODULE_1__.PureComponent);



/***/ }),

/***/ 44353:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ OnePagerAssetTemplatePage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_templates_one_pager_asset_template_one_pager_asset_template__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87355);
/* harmony import */ var _base_template_page__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79813);




function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}



var OnePagerAssetTemplatePage = /*#__PURE__*/ function(BaseTemplatePage) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(OnePagerAssetTemplatePage, BaseTemplatePage);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(OnePagerAssetTemplatePage);
    function OnePagerAssetTemplatePage() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, OnePagerAssetTemplatePage);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(OnePagerAssetTemplatePage, [
        {
            key: "render",
            value: function render() {
                var errorCode = this.props.errorCode;
                if (errorCode) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Error, {
                    statusCode: errorCode
                });
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_templates_one_pager_asset_template_one_pager_asset_template__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, _object_spread({}, this.props));
            }
        }
    ]);
    return OnePagerAssetTemplatePage;
}(_base_template_page__WEBPACK_IMPORTED_MODULE_2__["default"]);
var __N_SSP = true;



/***/ }),

/***/ 12918:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(89185)


/***/ }),

/***/ 5499:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;

(function(root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
		__WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
}(this, function(require,exports,module) {

return function ouibounce(el, custom_config) {
  "use strict";

  var config     = custom_config || {},
    aggressive   = config.aggressive || false,
    sensitivity  = setDefault(config.sensitivity, 20),
    timer        = setDefault(config.timer, 1000),
    delay        = setDefault(config.delay, 0),
    callback     = config.callback || function() {},
    cookieExpire = setDefaultCookieExpire(config.cookieExpire) || '',
    cookieDomain = config.cookieDomain ? ';domain=' + config.cookieDomain : '',
    cookieName   = config.cookieName ? config.cookieName : 'viewedOuibounceModal',
    sitewide     = config.sitewide === true ? ';path=/' : '',
    _delayTimer  = null,
    _html        = document.documentElement;

  function setDefault(_property, _default) {
    return typeof _property === 'undefined' ? _default : _property;
  }

  function setDefaultCookieExpire(days) {
    // transform days to milliseconds
    var ms = days*24*60*60*1000;

    var date = new Date();
    date.setTime(date.getTime() + ms);

    return "; expires=" + date.toUTCString();
  }

  setTimeout(attachOuiBounce, timer);
  function attachOuiBounce() {
    if (isDisabled()) { return; }

    _html.addEventListener('mouseleave', handleMouseleave);
    _html.addEventListener('mouseenter', handleMouseenter);
    _html.addEventListener('keydown', handleKeydown);
  }

  function handleMouseleave(e) {
    if (e.clientY > sensitivity) { return; }

    _delayTimer = setTimeout(fire, delay);
  }

  function handleMouseenter() {
    if (_delayTimer) {
      clearTimeout(_delayTimer);
      _delayTimer = null;
    }
  }

  var disableKeydown = false;
  function handleKeydown(e) {
    if (disableKeydown) { return; }
    else if(!e.metaKey || e.keyCode !== 76) { return; }

    disableKeydown = true;
    _delayTimer = setTimeout(fire, delay);
  }

  function checkCookieValue(cookieName, value) {
    return parseCookies()[cookieName] === value;
  }

  function parseCookies() {
    // cookies are separated by '; '
    var cookies = document.cookie.split('; ');

    var ret = {};
    for (var i = cookies.length - 1; i >= 0; i--) {
      var el = cookies[i].split('=');
      ret[el[0]] = el[1];
    }
    return ret;
  }

  function isDisabled() {
    return checkCookieValue(cookieName, 'true') && !aggressive;
  }

  // You can use ouibounce without passing an element
  // https://github.com/carlsednaoui/ouibounce/issues/30
  function fire() {
    if (isDisabled()) { return; }

    if (el) { el.style.display = 'block'; }

    callback();
    disable();
  }

  function disable(custom_options) {
    var options = custom_options || {};

    // you can pass a specific cookie expiration when using the OuiBounce API
    // ex: _ouiBounce.disable({ cookieExpire: 5 });
    if (typeof options.cookieExpire !== 'undefined') {
      cookieExpire = setDefaultCookieExpire(options.cookieExpire);
    }

    // you can pass use sitewide cookies too
    // ex: _ouiBounce.disable({ cookieExpire: 5, sitewide: true });
    if (options.sitewide === true) {
      sitewide = ';path=/';
    }

    // you can pass a domain string when the cookie should be read subdomain-wise
    // ex: _ouiBounce.disable({ cookieDomain: '.example.com' });
    if (typeof options.cookieDomain !== 'undefined') {
      cookieDomain = ';domain=' + options.cookieDomain;
    }

    if (typeof options.cookieName !== 'undefined') {
      cookieName = options.cookieName;
    }

    document.cookie = cookieName + '=true' + cookieExpire + cookieDomain + sitewide;

    // remove listeners
    _html.removeEventListener('mouseleave', handleMouseleave);
    _html.removeEventListener('mouseenter', handleMouseenter);
    _html.removeEventListener('keydown', handleKeydown);
  }

  return {
    fire: fire,
    disable: disable,
    isDisabled: isDisabled
  };
}

/*exported ouibounce */
;

}));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [296,8595,4218,6250,9861,627,4148,9112,8124,1882,3971,1971,6528,9774,2888,179], function() { return __webpack_exec__(78330); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);